export interface ConsentSignature {
  label: string;
  name: string;
  via: string;
  when: string;
}

const SIGN_VIA = {mobile_portal: 'Patient Portal / Mobile App', care_team: 'Care Team Device'};

// Date and time are shown exactly as entered at signing (no timezone conversion, so the day can never shift).
function signedAtText(signedAtDate: any, signedAtTime: any): string {
  const date = String(signedAtDate || '').split('T')[0].match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!date) {
    return '';
  }
  let text = `${date[2]}/${date[3]}/${date[1]}`;
  const time = String(signedAtTime || '').match(/^(\d{1,2}):(\d{2})/);
  if (time && +time[1] < 24 && +time[2] < 60) {
    const hour = +time[1];
    text += ` ${hour % 12 || 12}:${time[2]} ${hour < 12 ? 'AM' : 'PM'}`;
  }
  return text;
}

// Works on a Consent model or on the raw API json. Returns null unless the server confirmed a signer.
export function consentSignature(consent: any): ConsentSignature | null {
  const name = consent && consent.signer_name ? String(consent.signer_name).trim() : '';
  if (!name) {
    return null;
  }
  const from = consent.consent_from;
  const recorded = from === 'verbally' || from === 'paper';
  return {
    label: from === 'verbally' ? 'Verbal consent recorded by' : from === 'paper' ? 'Paper consent recorded by' : 'Electronically signed by',
    name: name.replace(/\s+/g, ' ').replace(/(^|\s)(\S)/g, (m, sp, ch) => sp + ch.toUpperCase()),
    via: recorded ? '' : (SIGN_VIA[from] || ''),
    when: signedAtText(consent.signed_at_date, consent.signed_at_time)
  };
}
